
export const fabOverlayStyle = {
    position: 'absolute',
    bottom: 16,
    right: 24,
}